export const stringHasNumbers = (stringValue: string) => {
  return /\d/.test(stringValue)
}

export const convertStringToNumber = (stringValue: string) => {
  return stringHasNumbers(stringValue) && Number(stringValue.replace(/\D/g, ''))
}

export const toLocalizedNumber = (amount: Number, currency: string) =>
  amount.toLocaleString('en-US', {
    style: 'currency',
    currency,
  })